import { apiClient } from '@/shared/api';

import type {
  MeasurementFamily,
  MeasurementFamilyCreateRequest,
  MeasurementFamilyUpdateRequest,
} from '../model/types';

const BASE = '/api/v1/catalog/measurement-families';

/**
 * List the tenant's measurement families (epic-catalog-005, user-story-catalog-013). The 5
 * standard families (WEIGHT/LENGTH/VOLUME/AREA/DURATION) are auto-created on first access.
 */
export const listMeasurementFamilies = async (): Promise<MeasurementFamily[]> =>
  (await apiClient.get<MeasurementFamily[]>(BASE)).data;

export const getMeasurementFamily = async (code: string): Promise<MeasurementFamily> =>
  (await apiClient.get<MeasurementFamily>(`${BASE}/${encodeURIComponent(code)}`)).data;

export const createMeasurementFamily = async (
  body: MeasurementFamilyCreateRequest,
): Promise<MeasurementFamily> => (await apiClient.post<MeasurementFamily>(BASE, body)).data;

/** Rejected with `409 STANDARD_FAMILY_READONLY` for one of the 5 standard families. */
export const updateMeasurementFamily = async (
  code: string,
  body: MeasurementFamilyUpdateRequest,
): Promise<MeasurementFamily> =>
  (await apiClient.patch<MeasurementFamily>(`${BASE}/${encodeURIComponent(code)}`, body)).data;

/** Rejected with `409 STANDARD_FAMILY_READONLY` (standard family) or `409 MEASUREMENT_FAMILY_IN_USE`. */
export const deleteMeasurementFamily = async (code: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${encodeURIComponent(code)}`);
};
